<template>
  <div class="kf-container" ref="kfContainer">
    <div class="kf telegram flex flex-align-center flex-justify-center" data-aos="zoom-in" @click="openRandomLink(1)">
      <img src="@/assets/image/Slice 32@3x(3).png" />{{ $t('kf.telegram') }}
    </div>
    <!-- <div class="kf wechat flex flex-align-center flex-justify-center" data-aos="zoom-in" @click="openRandomLink(2)">
      <img src="@/assets/image/Slice 32@3x(4).png" />{{ $t('kf.wechat') }}
    </div> -->
  </div>
</template>
<script>
import {openRandomLink} from '@/utils'
export default {
  props: {
    kfTop: {
      type: String,
      default: () => '608px'
    }
  },
  data() {
    return {}
  },
  methods: {
    openRandomLink: openRandomLink,
    toKf(){
      const target = this.$refs.kfContainer;
      const offset = 200; // 额外的偏移量，单位是像素

      if (target) {
        const rect = target.getBoundingClientRect(); // 获取元素相对于视口的位置
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop; // 当前页面已滚动的距离
        const targetY = rect.top + scrollTop - offset; // 计算目标位置并减去偏移量

        // 平滑滚动到目标位置
        window.scrollTo({
          top: targetY,
          behavior: 'smooth',
        });
      }
      // openRandomLink(1)
    }
  }
}
</script>
<style lang="less" scoped>
.kf-container{
  position: fixed;
  left: 280px;
  z-index: 20;
  /** top: 608px; **/
  bottom: 80px;
  display: none;
}
.kf {
  width: 238px;
  height: 68px;
  background: #FFFFFF;
  box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.1), 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  border-radius: 34px 34px 34px 34px;
  font-family: Inter, Inter;
  font-weight: 400;
  font-size: 20px;
  color: #000000;
  cursor: pointer;
  margin-bottom: 22px;
  animation: animate1 1s linear infinite;
  img {
    width: 48px;
    height: 48px;
    margin-right: 10px;
  }
}
</style>